import PostContent from "components/TimelinePostList/TimelinePost/PostContent";
import PostFooter from "components/TimelinePostList/TimelinePost/PostFooter";
import PostHeader from "components/TimelinePostList/TimelinePost/PostHeader";

const InnovationVistaPostItem = ({ companyData, total, isCompanyExist }) => {

  if (isCompanyExist && total === 0) {
    return (
      (
        <div
          style={{
            height: "80vh",
          }}
          className="d-flex justify-content-center align-items-center"
        >
          <p className="text-danger">
            <h5>There isn't any post shared in the company</h5>
          </p>
        </div>
      )
    )
  }

  if (!isCompanyExist) {
    return (
      (
        <div
          style={{
            height: "80vh",
          }}
          className="d-flex justify-content-center align-items-center"
        >
          <p className="text-danger">
            <h5>Unfortunately your team isn't part of any company.</h5>
          </p>
        </div>
      )
    )
  }

  function getDynamicStyle(post) {
    const color = (post?.data?.color ?? { name: "white" }).name.toLowerCase();
    const color_gradient = post?.data?.color?.color_gradient ?? ["#fff"];
    const textColor = color === "white" ? "#575F6B" : "white";

    return {
      background:
        post.type === "welcomemessage"
          ? "linear-gradient(#00A3A3, #8AFFFF)"
          : `linear-gradient(0deg, ${color_gradient[1] ?? color_gradient[0]
          } 0%, ${color_gradient[0]} 80%)`,
      color: post.type === "welcomemessage" ? "white" : textColor,
      fill: textColor,
      borderRadius: "6px",
      padding: "20px",
    };
  }

  const checkColor  = (post) => {
    const color = (post?.data?.color ?? { name: "white" }).name.toLowerCase();

    return color
  }

  return (
    companyData.map((post, index) => (
      <div className="w-100 d-flex flex-column gap-2 per_post"
        style={getDynamicStyle(post)}
        key={index}>
        <PostHeader post={post} color={checkColor(post)}/>
        <PostContent post={post} />
        <PostFooter post={post} innovation_dashboard={true}/>
      </div>
    ))
  );
};

export default InnovationVistaPostItem;
